import "./SupportTable.css";

export interface ValorLiberadoItem {
  ref?: string;
  historico?: string;
  vencimento?: string;
  valor?: string;
}

export interface SupportTableProps {
  dadosValoresLiberados?: ValorLiberadoItem[];
  totalValoresLiberados?: string;
  pendenteLiberacao?: string;
  liquidoApoio?: string;
}

const SupportTable = ({
  dadosValoresLiberados = [],
  totalValoresLiberados = "R$0,00",
  pendenteLiberacao = "R$0,00",
  liquidoApoio = "R$0,00",
}: SupportTableProps) => (
  <div>
    <div className="support-valores-liberados-title">VALORES LIBERADOS</div>
    <table className="support-valores-liberados-table">
      <thead>
        <tr>
          <th>REF PROTHEUS</th>
          <th>HISTÓRICO</th>
          <th>DATA DE VENCIMENTO</th>
          <th>VALOR APOIADO</th>
        </tr>
      </thead>
      <tbody>
        {dadosValoresLiberados.map((item, idx) => (
          <tr key={idx}>
            <td>{item.ref}</td>
            <td>{item.historico}</td>
            <td>{item.vencimento}</td>
            <td>{item.valor}</td>
          </tr>
        ))}
        <tr>
          <td colSpan={4}>&nbsp;</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={3} className="text-end">
            TOTAL DOS VALORES LIBERADOS
          </td>
          <td>{totalValoresLiberados}</td>
        </tr>
      </tfoot>
    </table>
    <div className="support-valores-liberados-instrucao">
      Não realizar deduções em parcela de bônus extra
    </div>

    <div className="support-bloco-azul">
      <div className="label">PENDENTE DE LIBERAÇÃO</div>
      <div className="valor">{pendenteLiberacao}</div>
    </div>
  </div>
);

export default SupportTable;
